module.exports = __webpack_public_path__ + "img/img06.b856d63c.png";